export async function apiCall(method, input, body) {
    try {
        const response = await fetch(input, {
            method,
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
            },
            body: body ? JSON.stringify(body) : undefined,
        });
        if (!response.ok) {
            return {
                status: 'network error',
                httpStatus: response.status,
                message: await response.text(),
            };
        }
        const data = await response.json();
        return data;
    }
    catch (error) {
        if (error instanceof Error) {
            return {
                status: 'network error',
                httpStatus: 0,
                message: error.message,
            };
        }
        return {
            status: 'network error',
            httpStatus: 0,
            message: 'An unknown error occurred',
        };
    }
}
//# sourceMappingURL=apiCall.js.map